var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 43,
    viewBox: "0 0 51 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.5C20.7239 14.5 20.5 14.7239 20.5 15C20.5 15.2761 20.7239 15.5 21 15.5V14.5ZM41 15.5C41.2761 15.5 41.5 15.2761 41.5 15C41.5 14.7239 41.2761 14.5 41 14.5V15.5ZM21 15.5H41V14.5H21V15.5Z",
    fill: "#002A66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21.5C30.2761 21.5 30.5 21.7239 30.5 22C30.5 22.2761 30.2761 22.5 30 22.5V21.5ZM10 22.5C9.72386 22.5 9.5 22.2761 9.5 22C9.5 21.7239 9.72386 21.5 10 21.5V22.5ZM30 22.5H10V21.5H30V22.5Z",
    fill: "#002A66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28.5C20.7239 28.5 20.5 28.7239 20.5 29C20.5 29.2761 20.7239 29.5 21 29.5V28.5ZM41 29.5C41.2761 29.5 41.5 29.2761 41.5 29C41.5 28.7239 41.2761 28.5 41 28.5V29.5ZM21 29.5H41V28.5H21V29.5Z",
    fill: "#002A66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.5C15.2761 15.5 15.5 15.2761 15.5 15C15.5 14.7239 15.2761 14.5 15 14.5V15.5ZM10 14.5C9.72386 14.5 9.5 14.7239 9.5 15C9.5 15.2761 9.72386 15.5 10 15.5V14.5ZM15 14.5H10V15.5H15V14.5Z",
    fill: "#002A66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 22.5C35.7239 22.5 35.5 22.2761 35.5 22C35.5 21.7239 35.7239 21.5 36 21.5V22.5ZM41 21.5C41.2761 21.5 41.5 21.7239 41.5 22C41.5 22.2761 41.2761 22.5 41 22.5V21.5ZM36 21.5H41V22.5H36V21.5Z",
    fill: "#002A66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 29.5C15.2761 29.5 15.5 29.2761 15.5 29C15.5 28.7239 15.2761 28.5 15 28.5V29.5ZM10 28.5C9.72386 28.5 9.5 28.7239 9.5 29C9.5 29.2761 9.72386 29.5 10 29.5V28.5ZM15 28.5H10V29.5H15V28.5Z",
    fill: "#002A66"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 15,
    r: 2.5,
    stroke: "#002A66"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 33 22)",
    stroke: "#002A66"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 29,
    r: 2.5,
    stroke: "#002A66"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.28fe01e1f135f028806e209fe445b95d.svg";
export { ForwardRef as ReactComponent };